

export function getFileWorkBookHerader(letter: number, row: number, sheet: any, skip: number = 0) {

    //Convert letter which is an index of columns, to excel's column name, taking into acccount AAA etc, so index = 1, column B
    let columnName = '';
    letter += skip;
    while (letter >= 0) {
        columnName = String.fromCharCode((letter % 26) + 65) + columnName;
        letter = Math.floor(letter / 26) - 1;
    }
        
    const cell = sheet[columnName + row];
    return cell?.v || "-";
}

export function processBooleanCells(value: string) {
    let result = false;
    if (value === "Yes" || value === "yes" || value === "YES" || value === "Y" || value === "y" || value === "true" || value === "True" || value === "TRUE") {
        return true;
    }
    return result;
}

export function columnsOptionsCheck(column: any, columnsOptions: Array<any>) {
    let options: any = "";
    columnsOptions.forEach((columnOption: any) => {
        if (columnOption.columnIndex === column.accessor) options = columnOption.id;
    });
    return options;
}

export function columnsOptionsValue(value: any, columnsOptions: Array<any>) {
    let options: any = "";
    columnsOptions.forEach((columnOption: any, index: number) => {
        if (value === columnOption) options = index;
    });
    return options;
}